module.exports = __webpack_public_path__ + "img/titlePc25-safeimagekit.3068fa64.png";